import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AboutPage from "./components/JuanEMS/AboutPage";
import HomePage from "./components/JuanEMS/HomePage";
import PrivacyPolicyPage from "./components/JuanEMS/PrivacyPolicyPage";
import SplashScreen from "./components/JuanEMS/SplashScreen";
import TermsOfUsePage from "./components/JuanEMS/TermsOfUsePage";
import Register from "./components/JuanScope/Register";
import Register2 from "./components/JuanScope/Register2";
import Register3 from "./components/JuanScope/Register3";
import RegistrationStatusComplete from "./components/JuanScope/RegistrationStatusComplete";
import ScopeAdmissionApproval from "./components/JuanScope/ScopeAdmissionApproval";
import ScopeAdmissionExamDetails from "./components/JuanScope/ScopeAdmissionExamDetails";
import ScopeAdmissionRequirements from "./components/JuanScope/ScopeAdmissionRequirements";
import ScopeAnnouncement from "./components/JuanScope/ScopeAnnouncement";
import ScopeDashboard from "./components/JuanScope/ScopeDashboard";
import ScopeExamFeePayment from "./components/JuanScope/ScopeExamFeePayment";
import ScopeExamInterviewApplication from "./components/JuanScope/ScopeExamInterviewApplication";
import ScopeExamInterviewResult from "./components/JuanScope/ScopeExamInterviewResult";
import ScopeLogin from "./components/JuanScope/ScopeLogin";
import ScopeRegistration1 from "./components/JuanScope/ScopeRegistration1";
import ScopeRegistration2 from "./components/JuanScope/ScopeRegistration2";
import ScopeRegistration3 from "./components/JuanScope/ScopeRegistration3";
import ScopeRegistration4 from "./components/JuanScope/ScopeRegistration4";
import ScopeRegistration5 from "./components/JuanScope/ScopeRegistration5";
import ScopeRegistration6 from "./components/JuanScope/ScopeRegistration6";
import ScopeReservationPayment from "./components/JuanScope/ScopeReservationPayment";
import SessionManager from "./components/JuanScope/SessionManager";
import VerifyEmail from "./components/JuanScope/VerifyEmail";
import VerifyOTP from "./components/JuanScope/VerifyOTP";
import ResetPassword from "./components/JuanScope/ResetPassword";
import JuanISResetPassword from "./components/JuanIS/JuanISResetPassword";
import ScopeEnrollmentRequirements from "./components/JuanScope/ScopeEnrollmentRequirements";
import JuanISLogin from "./components/JuanIS/JuanISLogin";
import JuanISStudentDashboard from "./components/JuanIS/JuanISStudentDashboard";
import JuanISFacultyDashboard from "./components/JuanIS/JuanISFacultyDashboard";
import ForgotPasswordOfficial from "./components/JuanIS/ForgotPasswordOfficial";
import JuanISClassSchedule from "./components/JuanIS/JuanISClassSchedule";
import JuanISFacultyClassInformatoion from "./components/JuanIS/JuanISFacultyClassInformation";
import JuanISFacultyClassSchedule from "./components/JuanIS/JuanISFacultyClassSchedule";
import JuanISFacultyGrades from "./components/JuanIS/JuanISFacultyGrades";
import JuanISFacultyOTE from "./components/JuanIS/JuanISFacultyOTE";
import JuanISFlowchart from "./components/JuanIS/JuanISFlowchart";
import JuanISOnlineTeacherEvaluation from "./components/JuanIS/JuanISOnlineTeacherEvaluation";
import JuanISPayBills from "./components/JuanIS/JuanISPayBills";
import JuanISProfile from "./components/JuanIS/JuanISProfile";
import JuanISServices from "./components/JuanIS/JuanISServices";
import JuanISStudentLedger from "./components/JuanIS/JuanISStudentLedger";
import JuanISVerifyOTP from "./components/JuanIS/JuanISVerifyOTP";
import JuanISFacultyAnnouncements from "./components/JuanIS/JuanISFacultyAnnouncements";

import ForgotPasswordApplicant from "./components/JuanScope/ForgotPasswordApplicant";
import VerifyOTPForgotPassword from "./components/JuanScope/VerifyOTPForgotPassword";
import ManageReviewApplicants from "./components/JuanScope/ManageReviewApplications/ManageReviewApplicants";
import ScopeVoucherApplication from "./components/JuanScope/ScopeVoucherApplication";
import ScopeEnrollmentApproval from "./components/JuanScope/ScopeEnrollmentApproval";
import { ToastContainer } from "react-toastify";
import ScopeStudentAssessment from "./components/JuanScope/ScopeStudentAssesment";
import SelectPaymentMethod from "./components/JuanScope/SelectPaymentMethod";
import ScopeOfficiallyEnrolled from "./components/JuanScope/OfficiallyEnrolled";

// LEGACY PAGES — These old routes are temporarily kept during frontend revisions.
// TODO: Remove them once the new interface is fully implemented.
import ManageApprovedInterviewSchedulesSection from "./components/JuanScope/ManageExamAndIntervewSchedule/ManageApprovedInterviewSchedulesSection";
import ManageExamAndInterviewScheduleSection from "./components/JuanScope/ManageExamAndIntervewSchedule/ManageExamAndInterviewScheduleSection";
import Admin_ManageEnrollmentPeriodPage from "./components/UserAdmin/ManageEnrollmentPeriodPage";

// REVISIONS --- These pages are still being updated.
import AdminLogin from "./components/UserAdmin/Authentication/AdminLogin";
import AdminForgotPassword from "./components/UserAdmin/Authentication/ForgotPassword";
import AdminVerifyEmail from "./components/UserAdmin/Authentication/VerifyEmail";
import AdminDashboard from "./components/UserAdmin/Dashboard";
import AdminQueueCounter from "./components/UserAdmin/Queue/QueueCounter";
import AdminEnrollmentTable from "./components/UserAdmin/Enrollment/EnrollmentTable";
import AdminApplicationsTable from "./components/UserAdmin/Applications/ApplicationsTable";
import AdminAccessControl from "./components/UserAdmin/Accounts/AccessControl";
import AdminAccountTable from "./components/UserAdmin/Accounts/AccountTable";
import AdminAccountForm from "./components/UserAdmin/Accounts/AccountForm";
import AdminFacultyProfileTable from "./components/UserAdmin/FacultyProfile/FacultyProfileTable";
import AdminFacultyProfileForm from "./components/UserAdmin/FacultyProfile/FacultyProfileForm";
import AdminScheduleTable from "./components/UserAdmin/Schedule/ScheduleTable";
import AdminScheduleForm from "./components/UserAdmin/Schedule/ScheduleForm";
import AdminStrandTable from "./components/UserAdmin/Strands/StrandTable";
import AdminStrandForm from "./components/UserAdmin/Strands/StrandForm";
import AdminSubjectTable from "./components/UserAdmin/Subjects/SubjectTable";
import AdminSubjectForm from "./components/UserAdmin/Subjects/SubjectForm";
import AdminSectionTable from "./components/UserAdmin/Sections/SectionTable";
import AdminSectionForm from "./components/UserAdmin/Sections/SectionForm";
import AdminUserLedgerTable from "./components/UserAdmin/UserLedger/UserLedgerTable";
import AdminUserLedgerForm from "./components/UserAdmin/UserLedger/UserLedgerForm";
import AdminSystemLogs from "./components/UserAdmin/SystemLogs/SystemLogs";
import AdminQueueHistory from "./components/UserAdmin/Queue/QueueHistory";
import AdminAnnouncementForm from "./components/UserAdmin/AnnouncementForm";
import AdminTuitionDetailsTable from "./components/UserAdmin/TuitionDetails/TuitionDetailsTable";
import AdminTuitionDetailsForm from "./components/UserAdmin/TuitionDetails/TuitionDetailsForm";
import AdminStudentRecordTable from "./components/UserAdmin/StudentRecords/StudentRecordTable";
import AdminStudentRecordForm from "./components/UserAdmin/StudentRecords/StudentRecordForm";
import AdminAcademicTermForm from "./components/UserAdmin/AcademicTerm/AcademicTermForm";
import AdminAcademicYearForm from "./components/UserAdmin/AcademicYear/AcademicYearForm";
import AdminPaymentHistory from "./components/UserAdmin/PaymentHistory/PaymentHistory";
import AdminVerifyLoginOtp from './components/UserAdmin/Authentication/VerifyLoginOtp';
import AdminPaymentsTable from "./components/UserAdmin/ProcessPayments/PaymentsTable"; 
import AdminPaymentsForm from "./components/UserAdmin/ProcessPayments/PaymentsForm"; 

function App() {
  return (
    <Router>
      <div className="App">
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
        <Routes>
          {/* Default Route (SplashScreen) */}
          <Route path="/" element={<SplashScreen />} />

          {/* Other routes */}
          <Route path="/home" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/terms-of-use" element={<TermsOfUsePage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />

          <Route path="/register" element={<Register />} />
          <Route path="/register2" element={<Register2 />} />
          <Route path="/register3" element={<Register3 />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route path="/scope-login" element={<ScopeLogin />} />
          <Route path="/juan-is-login" element={<JuanISLogin />} />
          <Route
            path="/scope-dashboard"
            element={
              <SessionManager>
                <ScopeDashboard />
              </SessionManager>
            }
          />
          <Route
            path="/scope-announcements"
            element={
              <SessionManager>
                <ScopeAnnouncement />
              </SessionManager>
            }
          />
          <Route
            path="/scope-voucher-application"
            element={
              <SessionManager>
                <ScopeVoucherApplication />
              </SessionManager>
            }
          />
          <Route
            path="/scope-registration"
            element={
              <SessionManager>
                <ScopeRegistration1 />
              </SessionManager>
            }
          />
          <Route
            path="/scope-voucher-application"
            element={
              <SessionManager>
                <ScopeVoucherApplication />
              </SessionManager>
            }
          />
          <Route
            path="/scope-registration-2"
            element={
              <SessionManager>
                <ScopeRegistration2 />
              </SessionManager>
            }
          />
          <Route
            path="/scope-registration-3"
            element={
              <SessionManager>
                <ScopeRegistration3 />
              </SessionManager>
            }
          />
          <Route
            path="/scope-registration-4"
            element={
              <SessionManager>
                <ScopeRegistration4 />
              </SessionManager>
            }
          />
          <Route
            path="/scope-registration-5"
            element={
              <SessionManager>
                <ScopeRegistration5 />
              </SessionManager>
            }
          />
          <Route
            path="/scope-registration-6"
            element={
              <SessionManager>
                <ScopeRegistration6 />
              </SessionManager>
            }
          />
          <Route
            path="/scope-registration-status-complete"
            element={
              <SessionManager>
                <RegistrationStatusComplete />
              </SessionManager>
            }
          />
          <Route
            path="/scope-enrollment-approval"
            element={
              <SessionManager>
                <ScopeEnrollmentApproval />
              </SessionManager>
            }
          />

          <Route
            path="/scope-exam-interview-application"
            element={
              <SessionManager>
                <ScopeExamInterviewApplication />
              </SessionManager>
            }
          />
          <Route
            path="/scope-officially-enrolled"
            element={
              <SessionManager>
                <ScopeOfficiallyEnrolled />
              </SessionManager>
            }
          />

          <Route
            path="/scope-student-assesment"
            element={
              <SessionManager>
                <ScopeStudentAssessment />
              </SessionManager>
            }
          />
          <Route
            path="/scope-admission-requirements"
            element={
              <SessionManager>
                <ScopeAdmissionRequirements />
              </SessionManager>
            }
          />
          <Route
            path="/scope-admission-exam-details"
            element={
              <SessionManager>
                <ScopeAdmissionExamDetails />
              </SessionManager>
            }
          />
          <Route
            path="/scope-exam-fee-payment"
            element={
              <SessionManager>
                <ScopeExamFeePayment />
              </SessionManager>
            }
          />
          <Route
            path="/scope-exam-interview-result"
            element={
              <SessionManager>
                <ScopeExamInterviewResult />
              </SessionManager>
            }
          />
          <Route
            path="/scope-reservation-payment"
            element={
              <SessionManager>
                <ScopeReservationPayment />
              </SessionManager>
            }
          />
          <Route
            path="/scope-admission-approval"
            element={
              <SessionManager>
                <ScopeAdmissionApproval />
              </SessionManager>
            }
          />
          <Route
            path="/scope-forgot-password"
            element={<ForgotPasswordApplicant />}
          />
          <Route
            path="/scope-enrollment-requirements"
            element={
              <SessionManager>
                <ScopeEnrollmentRequirements />
              </SessionManager>
            }
          />
          <Route
            path="/select-payment-method"
            element={
              <SessionManager>
                <SelectPaymentMethod />
              </SessionManager>
            }
          />

          <Route
            path="/juan-is-faculty-dashboard"
            element={
              <SessionManager>
                <JuanISFacultyDashboard />
              </SessionManager>
            }
          />

          <Route
            path="/juan-is-student-dashboard"
            element={
              <SessionManager>
                <JuanISStudentDashboard />
              </SessionManager>
            }
          />

          <Route path="/juanis-verify-otp" element={<JuanISVerifyOTP />} />
          <Route path="/juanis-forgot-password" element={<ForgotPasswordOfficial />} />
          <Route path="/juanis-verify-forgot-password-otp" element={<VerifyOTPForgotPassword />} />
          <Route path="/juanis-reset-password" element={<JuanISResetPassword />} />
          <Route
            path="/juan-is-faculty-announcements"
            element={
              <SessionManager>
                <JuanISFacultyAnnouncements />
              </SessionManager>
            }
          />

          <Route path="/scope-enrollment-requirements" element={<SessionManager><ScopeEnrollmentRequirements /></SessionManager>} />

          <Route
            path="/scope-forgot-password-otp-code"
            element={<VerifyOTPForgotPassword />}
          />

          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={<AdminLogin />}
          />
          <Route
            path="/admin/forgot-password"
            element={<AdminForgotPassword />}
          />
          <Route
            path="/admin/dashboard"
            element={<AdminDashboard />}
          />
          <Route
            path="/admin/manage-accounts"
            element={<AdminAccountTable />}
          />
          <Route
            path="/admin/manage-accounts/create"
            element={<AdminAccountForm />}
          />
          <Route
            path="/admin/manage-accounts/edit/:id"
            element={<AdminAccountForm />}
          />
          <Route
            path="/admin/manage-enrollment"
            element={<AdminEnrollmentTable />}
          />
          <Route
            path="/admin/manage-queue"
            element={<AdminQueueCounter />}
          />
          <Route path="/admin/queue-history"
            element={<AdminQueueHistory />}
          />
          <Route
            path="/admin/manage-system-logs"
            element={<AdminSystemLogs />}
          />
          <Route
            path="/admin/create-announcements"
            element={<AdminAnnouncementForm />}
          />
          <Route
            path="/admin/manage-strands"
            element={<AdminStrandTable />}
          />
          <Route
            path="/admin/manage-strands/create"
            element={<AdminStrandForm />}
          />
          <Route
            path="/admin/manage-strands/edit/:id"
            element={<AdminStrandForm />}
          />
          <Route
            path="/admin/manage-sections"
            element={<AdminSectionTable />}
          />
          <Route
            path="/admin/manage-sections/create"
            element={<AdminSectionForm />}
          />
          <Route
            path="/admin/manage-sections/edit/:id"
            element={<AdminSectionForm />}
          />
          <Route
            path="/admin/manage-subjects"
            element={<AdminSubjectTable />}
          />
          <Route
            path="/admin/manage-subjects/create"
            element={<AdminSubjectForm />}
          />
          <Route
            path="/admin/manage-subjects/edit/:id"
            element={<AdminSubjectForm />}
          />
          <Route
            path="/admin/access-control"
            element={<AdminAccessControl />}
          />
          <Route
            path="/admin/verify-email"
            element={<AdminVerifyEmail />}
          />
          <Route
            path="/admin/manage-exam-and-interview-schedule"
            element={<ManageExamAndInterviewScheduleSection />}
          />
          <Route
            path="/admin/manage-exam-and-interview-results"
            element={<ManageApprovedInterviewSchedulesSection />}
          />
          <Route
            path="/admin/manage-review-applicants"
            element={<ManageReviewApplicants />}
          />
          <Route
            path="/admin/manage-enrollment-period"
            element={<Admin_ManageEnrollmentPeriodPage />}
          />
          <Route
            path="/admin/manage-terms/create"
            element={<AdminAcademicTermForm />}
          />
          <Route
            path="/admin/manage-terms/edit/:id"
            element={<AdminAcademicTermForm />}
          />
          <Route
            path="/admin/manage-terms/view/:id"
            element={<AdminAcademicTermForm />}
          />
          <Route
            path="/admin/manage-years/create"
            element={<AdminAcademicYearForm />}
          />
          <Route
            path="/admin/manage-years/edit/:id"
            element={<AdminAcademicYearForm />}
          />
          <Route
            path="/admin/manage-years/view/:id"
            element={<AdminAcademicYearForm />}
          />
          <Route
            path="/admin/manage-tuition-details"
            element={<AdminTuitionDetailsTable />}
          />
          <Route
            path="/admin/manage-tuition-details/create"
            element={<AdminTuitionDetailsForm />}
          />
          <Route
            path="/admin/manage-tuition-details/edit/:id"
            element={<AdminTuitionDetailsForm />}
          />
          <Route
            path="/admin/manage-user-ledger"
            element={<AdminUserLedgerTable />}
          />
          <Route
            path="/admin/manage-user-ledger/view/:id"
            element={<AdminUserLedgerForm />}
          />
          <Route
            path="/admin/payment-history"
            element={<AdminPaymentHistory />}
          />
          <Route
            path="/admin/manage-students"
            element={<AdminStudentRecordTable />}
          />
          <Route
            path="/admin/manage-students/view/:id"
            element={<AdminStudentRecordForm />}
          />
          <Route
            path="/admin/verify-login-otp"
            element={<AdminVerifyLoginOtp />}
          />
          <Route path="/user-admin/dashboard"
            element={<AdminDashboard />}
          />
          <Route path="/user-admin/applications"
            element={<AdminApplicationsTable />}
          />
          <Route path="/user-admin/faculty-profile"
            element={<AdminFacultyProfileTable />}
          />
          <Route
            path="/user-admin/faculty-profile/create"
            element={<AdminFacultyProfileForm />}
          />
          <Route
            path="/user-admin/faculty-profile/edit/:id"
            element={<AdminFacultyProfileForm />}
          />
          <Route
            path="/user-admin/faculty-profile/view/:id"
            element={<AdminFacultyProfileForm />}
          />
          <Route path="/user-admin/schedule"
            element={<AdminScheduleTable />}
          />
          <Route path="/user-admin/schedule/create"
            element={<AdminScheduleForm />}
          />
          <Route path="/user-admin/schedule/edit/:id"
            element={<AdminScheduleForm />}
          />
          <Route path="/user-admin/schedule/view/:id"
            element={<AdminScheduleForm />}
          />
          <Route path="/user-admin/payments"
            element={<AdminPaymentsTable />}
          />
          <Route path="/user-admin/payments/create"
            element={<AdminPaymentsForm />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
